import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Link,
  CircularProgress,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";

import * as PaymentActions from "../actions/PaymentActions";

import { loginUser, validateEmail } from "../utils"

const styles = (theme) => ({
  form: {
    padding: "6px 0",
  },
  loginBtn: {
    margin: "0 0 10px 0",
    height: "3rem",
  }
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPass: false,
      username: "",
      password: "",
    };
    this.toggleShowPass = this.toggleShowPass.bind(this);
    this.onUSerLogin = this.onUSerLogin.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  toggleShowPass = () => this.setState({ showPass: !this.state.showPass });

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.onUSerLogin();
    }
  }

  onUSerLogin = async () => {
    const { username, password } = this.state;
    const { actions } = this.props;
    if(username === "" || password === "")
      return actions.openSnackbar('error', 'Please fill in your details');

    actions.setLoading(true);

    let credentials = { password };

    if (validateEmail(username)) credentials.email = username;
    else credentials.username = username;


    try {
      const { userAccount, message } = await loginUser(credentials);

      if (userAccount) {
        actions.openSnackbar('success', 'Refreshing...');
        setTimeout(() => window.location.reload(), 2000);
      } else actions.openSnackbar('error', `${message || 'Unable to login. Please contact us at 03 9018 5438'}`, 10000);
    } catch (error) {
      actions.openSnackbar('error', `${error.message || 'Unable to login. Please contact us at 03 9018 5438.'}`, 10000);
    } finally {
      actions.setLoading(false);
    }
  }

  render = () => {
    let { state, props, toggleShowPass, onUSerLogin, onKeyDown } = this;
    let { toggleSignInForm, toggleForgotPass, classes, loading } = props;
    let { showPass, username, password } = state;
    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography
            style={{ display: "inline-block", textAlign: "right" }}
            variant="body2"
            align="right"
          >
            <Link onClick={toggleSignInForm} style={{ cursor: "pointer", color: "#155E98", fontSize: "1rem" }} ><strong>Create an account</strong></Link>
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ paddingBottom: "8px" }}>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom><strong>Member Login</strong></Typography>
        </Grid>

        <Grid item xs={12} className={classes.form}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="stretch"
            spacing={2}
          >
            <Grid item xs={12}>
              <TviTextFiled
                value={username}
                fullWidth
                id="client-uname"
                name="client[uname]"
                label="Username or Email"
                variant="outlined"
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TviTextFiled
                value={password}
                fullWidth
                id="client-pass"
                name="client[pass]"
                label="Password"
                variant="outlined"
                type={showPass ? "text" : "password"}
                onChange={(e) => this.setState({ password: e.target.value })}
                onKeyDown={onKeyDown}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleShowPass}>
                        {showPass ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                style={{ display: "inline-block", textAlign: "left" }}
                variant="caption"
                align="right"
              >
                For security reasons, all account passwords contain a minimum of 8 characters including at least one uppercase letter, one lowercase letter &amp; one number.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Button className={classes.loginBtn} variant="contained" color="primary" fullWidth onClick={onUSerLogin} disabled={loading}>
                {loading ? <CircularProgress size={20} /> : <Typography variant="h5">Login</Typography>}
              </Button>
            </Grid>

            <Grid item xs={12} style={{ paddingTop: "0" }}>
              <Typography
                style={{ display: "inline-block", textAlign: "right" }}
                variant="body2"
                align="right"
              >
                <Link onClick={toggleForgotPass} style={{ cursor: "pointer", fontSize: "1rem" }} ><strong>Forgotten Your Password?</strong></Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
}

const mapStateToProps = ({ payment }) => ({
  loading: payment.loading,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SignInForm));
